import React, { Component } from "react";
import { Card, CardBody, Button, Input, FormGroup, Label, Alert } from "reactstrap";
import { loginApi, isAuthenticated } from "./api";

class AiAdminLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      error: "",
      loading: false,
    };
  }

  componentDidMount() {
    if (isAuthenticated()) {
      this.props.history.push("/dashboard");
    }
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    const { username, password } = this.state;
    if (!username || !password) return;

    this.setState({ loading: true, error: "" });
    try {
      await loginApi(username, password);
      this.props.history.push("/dashboard");
    } catch (err) {
      this.setState({
        error: err.response?.data?.error || "Login failed",
        loading: false,
      });
    }
  };

  render() {
    const { username, password, error, loading } = this.state;

    return (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        }}
      >
        <Card style={{ width: 400, borderRadius: 12, boxShadow: "0 20px 60px rgba(0,0,0,0.3)" }}>
          <CardBody className="p-5">
            <div className="text-center mb-4">
              <h3 className="font-weight-bold" style={{ color: "#764ba2" }}>
                VMASS AI Admin
              </h3>
              <p className="text-muted">Dashboard quản lý AI</p>
            </div>

            {error && <Alert color="danger">{error}</Alert>}

            <form onSubmit={this.handleSubmit}>
              <FormGroup>
                <Label>Username</Label>
                <Input
                  type="text"
                  value={username}
                  onChange={(e) => this.setState({ username: e.target.value })}
                  placeholder="Enter username"
                  autoFocus
                />
              </FormGroup>
              <FormGroup>
                <Label>Password</Label>
                <Input
                  type="password"
                  value={password}
                  onChange={(e) => this.setState({ password: e.target.value })}
                  placeholder="Enter password"
                />
              </FormGroup>
              <Button
                color="primary"
                block
                type="submit"
                disabled={loading}
                style={{
                  background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  border: "none",
                  borderRadius: 8,
                  padding: "10px",
                }}
              >
                {loading ? "Logging in..." : "Login"}
              </Button>
            </form>
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default AiAdminLogin;
